/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestions.defs.js'
export { main as default } from './getSuggestions.defs.js'
